import * as React from "react";
import { faTrophyAlt } from "@fortawesome/pro-regular-svg-icons/faTrophyAlt";
import MuiIconFa, { MuiIconFaProps } from "components/MuiExtras/MuiIconFa";

const IconTrophyAlt: React.FC<Omit<MuiIconFaProps, "icon">> = (props) => {
    return <><MuiIconFa {...props} icon={faTrophyAlt} />&nbsp;</>
}

export default IconTrophyAlt

